import jQuery from 'jquery';
import { setMenuMinHeight } from '../misc/scroll-helpers';
import { tdAnimationScroll, tdBackstr } from '../animation/animation-scroll';
import { tdAnimationStack, td_backstretch_items, td_compute_backstretch_item } from '../animation/animation-stack';
import { tdPullDown } from '../layout/pull-down';

export const tdCustomEvents: Record<string, any> = {


    /**
     * - callback real scroll called from td_events
     * @private
     */
    _callback_scroll: function() {
        tdAnimationScroll.compute_all_items();
    },


    /**
     * - callback real resize called from td_events
     * @private
     */
    _callback_resize: function() {

    },


    /**
     * - callback lazy scroll called from td_events at 100ms
     * @private
     */
    _lazy_callback_scroll_100: function() {
        if ( true === tdAnimationStack.activated ) {
            tdAnimationStack.td_events_scroll();
        }
    },


    /**
     * - callback lazy scroll called from td_events at 500ms
     * @private
     */
    _lazy_callback_scroll_500: function() {

    },



    /**
     * - callback lazy resize called from td_events at 100ms
     * @private
     */
    _lazy_callback_resize_100: function() {
        tdPullDown.td_events_resize();
        tdBackstr.td_events_resize();
        tdAnimationScroll.td_events_resize();
    },


    /**
     * - callback lazy resize called from td_events at 500ms
     * @private
     */
    _lazy_callback_resize_500: function() {
        if ( true === tdAnimationStack.activated ) {
            tdAnimationStack.td_events_resize();
        }

        // - every tdAnimationScroll.item item of the td_backstretch_items array must be reinitialized and repositioned for parallax effect
        for ( var i = 0; i < td_backstretch_items.length; i++ ) {
            tdAnimationScroll.reinitialize_item( td_backstretch_items[ i ], true );
            td_compute_backstretch_item( td_backstretch_items[ i ] );

            // compute_all_items is used instead, for requestAnimationFrame
            //tdAnimationScroll.compute_item(td_backstretch_items[i]);
        }

        // for better performance it's used tdAnimationScroll.compute_all_items, because it uses requestAnimationFrame
        tdAnimationScroll.compute_all_items();

        // @todo It will be refactorized when td_site will be
        setMenuMinHeight();


        // Stretch video background
        jQuery( 'body' ).find( '.tdc-video-inner-wrapper' ).each(function() {

            var $wrapper = jQuery( this ),
                $iframe = $wrapper.find( 'iframe' );

            if ( ! $iframe.length ) {
                return;
            }

            var iframeAspectRatio = $iframe.attr( 'aspect-ratio' );

            if ( 'undefined' === typeof iframeAspectRatio ) {
                return;
            }

            var wrapperWidth = $wrapper.width(),
                wrapperHeight = $wrapper.height(),
                wrapperAspectRatio = wrapperHeight / wrapperWidth;

            // @ts-ignore
            if ( iframeAspectRatio < wrapperAspectRatio ) {
                $iframe.css({
                    // @ts-ignore
                    width: wrapperHeight / iframeAspectRatio,
                    height: wrapperHeight
                });
            // @ts-ignore
            } else if ( iframeAspectRatio > wrapperAspectRatio ) {
                $iframe.css({
                    width: '100%',
                    // @ts-ignore
                    height: iframeAspectRatio * wrapperWidth
                });
            }
        });


        // every tdAnimationScroll.item item which has 'td_video_parallax' flag must be reinitialized and repositioned for parallax effect
        for ( var i = 0; i < tdAnimationScroll.items.length; i++ ) {
            if ( 'undefined' !== typeof tdAnimationScroll.items[i].td_video_parallax ) {
                tdAnimationScroll.reinitialize_item( tdAnimationScroll.items[i], true );
            }
        }

    }
};
